import { Injectable }       from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }                 from '../api/api.service';
import { ConfirmService }             from '../messages/confirm/confirm.service';
import { TaxGroupItemAttributeModel } from './typings/tax-group.item-attributes';
import { TaxGroupModel }              from './typings/tax-group';

@Injectable({
  providedIn: 'root'
})
export class TaxGroupsService {
  constructor (
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private translateService: TranslateService
  ) {}

  create ( group : TaxGroupModel ) : Promise<any> {
    return this.apiService.post('/tax_groups', group, 'tax_group');
  }

  delete ( group : TaxGroupModel ) : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('GENERAL_SPACE.STATUS.ARE_YOU_SURE_YOU_WANT_TO_DELETE'))
      .then(() => this.apiService.delete('/tax_group', group.id));
  }

  deleteType ( type : TaxGroupItemAttributeModel ) : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('GENERAL_SPACE.STATUS.ARE_YOU_SURE_YOU_WANT_TO_DELETE'))
      .then(() => this.apiService.delete('/tax_group_item', type.id));
  }

  get () : Promise<Array<TaxGroupModel>> {
    return this.apiService.get('/tax_groups');
  }

  update ( group : TaxGroupModel ) : Promise<any> {
    return this.apiService.patch('/tax_group', group, 'tax_group');
  }
}
